<template>
  <v-row
    @contextmenu="handleContextMenuRow($event)"
    @mouseup.stop="handleMouseUp"
    :style="{
      backgroundColor: riga.selezionata === 0 ? riga.colore_riga : '#808080',
      border: '1px solid black',
      padding: '5px',
    }"
  >
    <v-col cols="12" class="my-0 py-0" dense v-if="riga.intestazione == 1">
      <span style="color:orange; font-weight:bold;"> Intestazione </span>
    </v-col>
    <LayoutColumn
      :colonna="colonna"
      :drag_state="drag_state"
      :is_intestazione="
        riga.intestazione == 1 || is_intestazione == 1 ? 1 : is_intestazione
      "
      :key="i"
      v-for="(colonna, i) in riga.colonne.filter((c) => c.validita == 1)"
    ></LayoutColumn>
  </v-row>
</template>
<script>
export default {
  name: "LayoutRow",
  components: {
    LayoutColumn: () => import("@/components/LAYOUT/LayoutColumn.vue"),
  },
  props: {
    drag_state: { type: String, default: "off" },
    is_intestazione: { type: Number, default: 0 },
    riga: { type: Object, default: () => {} },
  },
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    handleMouseUp() {
      if (this.drag_state == "on") {
        this.handleDragEnd();
      } else {
        this.handleClick();
      }
    },
    handleClick() {
      // Costruisco un messaggio.
      const messaggio = {
        detail: {
          id_layout_struttura_tmp: this.riga.id_layout_struttura_tmp,
        },
        src: null,
      };

      // Metto il messaggio nell'evento.
      const evento = new CustomEvent("clickedRow", messaggio);

      // Consegno l'evento alla mia destinazione.
      document.getElementById("listener_layout").dispatchEvent(evento);
    },
    handleContextMenuRow(e) {
      // Ho cliccato col destro, ma prevengo il menu contestuale del browser. */
      e.preventDefault();

      // Costruisco un messaggio.
      const messaggio = {
        detail: {
          id_layout_struttura_tmp: this.riga.id_layout_struttura_tmp,
        },
        src: null,
      };

      // Metto il messaggio nell'evento.
      const evento = new CustomEvent("contextMenuRow", messaggio);

      // Consegno l'evento alla mia destinazione.
      document.getElementById("listener_layout").dispatchEvent(evento);
    },
    handleDragEnd() {
      // Costruisco un messaggio.
      const messaggio = {
        detail: {
          id_layout_struttura_tmp: this.riga.id_layout_struttura_tmp,
        },
        src: null,
      };

      // Metto il messaggio nell'evento.
      const evento = new CustomEvent("endOfDrag", messaggio);

      // Consegno l'evento alla mia destinazione.
      document.getElementById("listener_layout").dispatchEvent(evento);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>